import { FC, ReactNode } from "react";
import { hexToRgb, isDarkColor } from "../../utils/convert";
import { QuizContext, QuizPublicInfo } from "./QuizContext";

type Props = {
  children: ReactNode;
  value: QuizPublicInfo;
  htmlDocument?: HTMLElement;
  session?: string;
};

export const QuizProvider: FC<Props> = ({
  children,
  value,
  htmlDocument,
  session
}) => {

  const { style } = htmlDocument ?? window.document.documentElement;
  style.setProperty("--bg-color", value.background_color ?? "");
  style.setProperty("--bg-color-rgb", hexToRgb(value.background_color ?? ""));
  style.setProperty("--bg-button", value.button_color ?? "");
  style.setProperty("--bg-button-rgb", hexToRgb(value.button_color ?? ""));
  style.setProperty("--text-color", value.text_color ?? "");
  style.setProperty("--text-color-rgb", hexToRgb(value.text_color ?? ""));
  style.setProperty("--title-text-color", value.text_color ?? "");
  style.setProperty("--title-text-color-rgb", hexToRgb(value.text_color ?? ""));
  style.setProperty("--button-text-color", value.button_text_color ?? "");
  style.setProperty(
    "--button-text-color-rgb",
    hexToRgb(value.button_text_color ?? "")
  );
  style.setProperty(
    "--article-bg",
    isDarkColor(value.background_color)
      ? "rgba(255, 255, 255, 0.07)"
      : "rgba(45, 55, 72, 0.07)"
  );
  style.setProperty(
    "--bg-back-button",
    isDarkColor(value.background_color)
      ? "rgba(255, 255, 255, 0.35)"
      : "rgba(45, 55, 72, 0.35)"
  );
  return (
    <QuizContext.Provider
      value={{ ...value, session}}
    >
      {children}
    </QuizContext.Provider>
  );
};

//export default QuizProvider;
